export abstract class StatusReferenceBase {
    public code: string;
    public name: string;
    public statusCode: string;
    public highlightColor: string;
}